import { render } from "./PartialNRIC.vue?vue&type=template&id=8e7b661a&scoped=true"
import script from "./PartialNRIC.vue?vue&type=script&lang=js"
export * from "./PartialNRIC.vue?vue&type=script&lang=js"

import "./PartialNRIC.vue?vue&type=style&index=0&id=8e7b661a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e7b661a"]])

export default __exports__